import { createVanIconComponent } from "./van"

const Bag = createVanIconComponent("bag")
export default Bag
